import { Box, Button, Input, Typography } from "@mui/material";
import React from "react";

type TDragDrop = {
  onFileSelect: (file?: File) => void;
  acceptedFiles: string;
  inputRef: React.RefObject<HTMLInputElement>;
  setIsDragging: React.Dispatch<React.SetStateAction<boolean>>;
  onClickBrowse: () => void;
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
};

export default function DragDrop({
  acceptedFiles,
  inputRef,
  onFileSelect,
  onClickBrowse,
  handleDrop,
  setIsDragging,
}: TDragDrop) {
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        gap: "10px",
      }}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragLeave={handleDragLeave}
    >
      <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: "400" }}>
        Drag and drop files or
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        size="large"
        onClick={onClickBrowse}
        sx={{ border: "1px solid rgba(0, 48, 135, 0.5)", color: " #003087" }}
      >
        Browse...
        <Input
          type="file"
          inputProps={{ accept: acceptedFiles }}
          inputRef={inputRef}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onFileSelect(event.target.files?.[0])}
          style={{ display: "none" }}
        />
      </Button>
    </Box>
  );
}
